<template>
  <div
    class="fixed z-50 top-3 md:top-6 right-0 px-3 md:px-6 flex flex-col gap-2 items-end pointer-events-none"
  >
    <transition-group name="toast-fade">
      <div
        v-for="toast in toastStore.toasts"
        :key="toast.id"
        class="px-4 py-3 rounded shadow-lg flex gap-2 max-w-[420px] w-full pointer-events-auto text-white"
        style="background-color: #171717;"
      >
        <span class="flex-1" v-html="toast.message"></span>
        <button
          class="ml-2 hover:opacity-70 cursor-pointer"
          :title="$t('common.close')"
          type="button"
          @click="toastStore.removeToast(toast.id)"
        >
          <CloseIcon class="w-5 h-5 fill-current" />
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script setup lang="ts">
  import { useToastStore } from '@/stores/toastStore';

  import CloseIcon from '../icons/CloseIcon.vue';

  const toastStore = useToastStore();
</script>

<style scoped>
  .toast-fade-enter-active,
  .toast-fade-leave-active {
    transition:
      opacity 0.3s,
      transform 0.3s;
  }
  .toast-fade-enter-from {
    opacity: 0;
    transform: translateY(-20px);
  }
  .toast-fade-leave-to {
    opacity: 0;
    transform: translateY(-20px);
  }
</style>
